import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import React from "react"

import { GalleryPictureItem } from "../../model/gallery-item"
import "./lightbox-picture.sass"

const LightboxPicture = ({ galleryPicture }) => {
  return (
    <div className="_fp-lightbox-picture">
      {galleryPicture.useGatsbyImage() ? (
        <GatsbyImage
          image={galleryPicture.gatsbyFluidImage}
          alt={galleryPicture.description || ""}
          className={"_fp-lightbox-picture__gatsby-image"}
          imgStyle={{ objectFit: "contain", objectPosition: "50% 50%" }}
        />
      ) : (
        <img
          className={"_fp-lightbox-picture__regular-img"}
          src={galleryPicture.imgSrc}
          alt={galleryPicture.description || ""}
        />
      )}
    </div>
  )
}

LightboxPicture.propTypes = {
  galleryPicture: PropTypes.instanceOf(GalleryPictureItem).isRequired,
}

export default LightboxPicture
